import Drawer from '@mui/material/Drawer';
import { memo } from 'react';
import SidebarNav from './components/SidebarNav/SidebarNav';

const drawerWidth = 280;

const PermanentSidebar = () => {
  return (
    <Drawer
      variant='permanent'
      sx={{
        display: { xs: 'none', md: 'block' },
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
          position: 'relative',
          borderRight: '1px solid',
          borderColor: 'divider',
        },
      }}
      open
    >
      <SidebarNav />
    </Drawer>
  );
};

export default memo(PermanentSidebar);
